import { useEffect, useState } from 'react';
import styles from './RequestTypeForms.module.scss';
import SelectDropdown from '../../../../utils/SelectDropdown';
import { TextareaAutosize } from '@material-ui/core';
import { statesWithId } from '../../../../components/body/support/forms/shared/FormsData';
import {
  normalizeInput,
  validateCode,
} from '../../../../components/body/checkout/sections/checkoutUtils';
import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '../../../../src/app/hooks';
import { validationTypes } from '../../../../commons/validations';
import { submitSupportTicket } from '../../../../src/features/user/userState';
import {
  cancellationReasons,
  getCancellationsReasons,
} from '../../../../src/features/subscription/subscriptionState';
import {
  cleanNameField,
  processNameField,
  phoneNumberLengthValidation,
  addressFormater,
  processEmailField,
  cleanEmailField,
  processCityField,
} from '../../../../commons/formatters';
import {
  removeCountryCodeAndFormat,
  setFormDataFieldValue,
} from '../../../../commons/utils/utils';
import { formatDateForApi, pauseIntervals } from '../../../../utils/Utils';
import {
  ADD1_REGISTER,
  ADD2_REGISTER,
  CITY_REGISTER,
  COMMENTS_REGISTER,
  EMAIL_REGISTER,
  FN_REGISTER,
  LN_REGISTER,
  PHONE_REGISTER,
  STATE_REGISTER,
  ZIP_REGISTER,
} from '../../../../commons/Constants';
import DatepickerComponent from '../../../../utils/Datepicker';
import {
  ContainedButton,
  CountryDropdown,
  TextInput,
} from '../../../../commons/hoc';
import TextAreaInput from '../../../../commons/hoc/Input/TextAreaInput/TextAreaInput';
import { BaseAddress } from '../../checkout/components';

const CancelForm = ({ currentOption, setFormSubmitted = () => {} }) => {
  const dispatch = useAppDispatch();
  const displayCancellationReasons = useAppSelector(cancellationReasons);
  const [cancelRadioButtonActive, setCancelRadioButtonActive] = useState(false);
  const [pauseRadioButtonActive, setPauseRadioButtonActive] = useState(true);
  const [resumeDate, setResumeDate] = useState('');
  statesWithId[0] = { ...statesWithId[0], alias: '', disabled: false };
  const [currentAddress, setCurrentAddress] = useState({});

  useEffect(() => {
    dispatch(getCancellationsReasons());
  }, []);

  const {
    register,
    formState,
    formState: { errors },
    handleSubmit,
    clearErrors,
    trigger,
    getValues,
    setValue,
  } = useForm({ mode: 'onBlur', reValidateMode: 'onBlur' });
  const onSubmit = (data) => {
    let subscriptionReminderData = cancelRadioButtonActive
      ? ''
      : data.subscriptionReminder === 'PLACE_HOLDER_OPTION'
        ? '2months'
        : data.subscriptionReminder;

    dispatch(
      submitSupportTicket({
        'qmonitorid': 35,
        'firstname': data.firstName,
        'lastname': data.lastName,
        'phone': removeCountryCodeAndFormat(data.phone, true),
        'email': data.email,
        'Custom[638]': data.address1,
        'Custom[639]': data.address2,
        'Custom[640]': data.city,
        'Custom[642]': statesWithId[data.state].alias,
        'Custom[643]': data.zip,
        'Custom[626]': cancelRadioButtonActive ? data.cancellation : '',
        'Custom[970]': cancelRadioButtonActive ? 'cancel' : 'pause',
        // 'Custom[972]': subscriptionReminderData, // ! replaced with 1073 delete after confirmation
        'Custom[1073]': resumeDate
          ? formatDateForApi(resumeDate.toString())
          : '',
        'message': data.comments,
      })
    );
    setFormSubmitted(true);
  };
  const handleAddressChange = (address, key) => {
    setValue(key, address, { shouldDirty: true });
  };
  const handleInputOnChange = (key, value) => {
    setValue(key, value, { shouldValidate: false, shouldTouch: true });
    clearErrors(key);
  };
  const [phoneNumber, setPhoneNumber] = useState('');
  const [zipCode, setZipCode] = useState('');

  const handleAutoComplete = (e) => {
    if (currentOption === 'cancel') {
      let target = Array.from(e.target.form);
      let tempFormData = {};
      target.forEach((item) => {
        if (item.name !== '' && item.name !== 'cancellation') {
          tempFormData[item.name] =
            item.name === PHONE_REGISTER
              ? normalizeInput(item.value)
              : item.value;
        }
      });
      setFormDataFieldValue(getValues(), tempFormData, setValue, trigger);
      setPhoneNumber(getValues().phone);
      setZipCode(getValues().zip);
    }
  };
  /* useEffect(() => {
    if (typeof window === 'object') {
      import('detect-autofill').then((mod) => {
        window.addEventListener('onautocomplete', handleAutoComplete);
      });
    }
  }, []); */

  const firstName = register(FN_REGISTER, {
    ...validationTypes.firstName,
    onChange: (e) => {
      e.target.value = processNameField(e.target.value);
      setValue(FN_REGISTER, e.target.value);
      clearErrors(FN_REGISTER);
    },
    onBlur: (e) => {
      setValue(FN_REGISTER, cleanNameField(e.target.value));
    },
  });

  const lastName = register(LN_REGISTER, {
    ...validationTypes.lastName,
    onChange: (e) => {
      e.target.value = processNameField(e.target.value);
      setValue(LN_REGISTER, e.target.value);
      clearErrors(LN_REGISTER);
    },
    onBlur: (e) => {
      setValue(LN_REGISTER, cleanNameField(e.target.value));
    },
  });

  const address1 = register(ADD1_REGISTER, {
    ...validationTypes.address1,
    onChange: (e) => {
      handleAddressChange(addressFormater(e.target.value), ADD1_REGISTER);
      clearErrors(ADD1_REGISTER);
    },
    onBlur: (e) => {
      handleAddressChange(
        addressFormater(e.target.value.trim()),
        ADD1_REGISTER
      );
    },
  });

  const address2 = register(ADD2_REGISTER, {
    ...validationTypes.address2,
    onChange: (e) => {
      handleAddressChange(addressFormater(e.target.value), ADD2_REGISTER);
      clearErrors(ADD2_REGISTER);
    },
    onBlur: (e) => {
      handleAddressChange(
        addressFormater(e.target.value.trim()),
        ADD2_REGISTER
      );
    },
  });

  const city = register(CITY_REGISTER, {
    ...validationTypes.city,
    onChange: (e) => {
      setValue(CITY_REGISTER, processCityField(e.target.value));
      clearErrors(CITY_REGISTER);
    },
    onBlur: (e) => {
      setValue(CITY_REGISTER, e.target.value.trim());
    },
  });

  const zip = register(ZIP_REGISTER, {
    ...validationTypes.zip,
    onChange: (e) => {
      setValue(ZIP_REGISTER, e.target.value);
      clearErrors(ZIP_REGISTER);
      setZipCode(validateCode(e.target.value, zipCode, 5));
    },
  });

  const phone = register(PHONE_REGISTER, {
    ...validationTypes.phone,
    onBlur: (e) => {
      setPhoneNumber(normalizeInput(e.target.value, phoneNumber));
    },
    onChange: (e) => {
      clearErrors(PHONE_REGISTER);
      let number = phoneNumberLengthValidation(e.target.value);
      if (number !== null) {
        setPhoneNumber(number);
      }
    },
  });

  const email = register(EMAIL_REGISTER, {
    ...validationTypes.email,
    onChange: (e) => {
      setValue(EMAIL_REGISTER, processEmailField(e.target.value));
      clearErrors(EMAIL_REGISTER);
    },
    onBlur: (e) => {
      setValue(EMAIL_REGISTER, cleanEmailField(e.target.value));
    },
  });

  const cancellation = register('cancellation', {
    required: cancelRadioButtonActive,
    validate: (value) => value !== 'Select Cancellation Reason',
  });

  const comments = register(COMMENTS_REGISTER, {
    required: false,
  });

  const handlePhoneNumber = (event) => {
    setPhoneNumber(event.target.value.replace(/\D/g, ''));
  };
  const subscriptionReminder = register('subscriptionReminder', {
    required: false,
    onChange: (e) => {
      handleInputOnChange('subscriptionReminder', e.target.value);
    },
  });
  const handleRadioButton = (value) => {
    if (value == 'Cancel') {
      setPauseRadioButtonActive(false);
      setCancelRadioButtonActive(true);
    } else {
      setPauseRadioButtonActive(true);
      setCancelRadioButtonActive(false);
    }
  };

  return (
    <div className={styles.supportFormsContainer}>
      <form onSubmit={handleSubmit(onSubmit)} id="form-cancel">
        {/* For safer side - Don't Delete below commented code */}
        {/* <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="First Name"
              required={validationTypes.firstName.required}
              register={firstName}
              maxLength={validationTypes.firstName.maxLength}
              errors={errors}
              placeholder="First Name"
            />
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="Last Name"
              required={validationTypes.lastName.required}
              register={lastName}
              maxLength={validationTypes.lastName.maxLength}
              errors={errors}
              placeholder="Last Name"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              type="tel"
              inputMode="numeric"
              register={phone}
              required={validationTypes.phone.required}
              label="Phone Number"
              placeholder="(XXX) XXX-XXXX"
              onFocus={handlePhoneNumber}
              onClickCapture={handlePhoneNumber}
              errors={errors}
              maxLength={validationTypes.phone.maxLength}
              value={phoneNumber}
            />
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              required={validationTypes.email.required}
              register={email}
              label="Email Address"
              maxLength={validationTypes.email.maxLength}
              errors={errors}
              placeholder="Email Address"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <TextInput
              required={validationTypes.address1.required}
              register={address1}
              label="Address - Line 1"
              maxLength={validationTypes.address1.maxLength}
              errors={errors}
              placeholder="Address - Line 1"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <TextInput
              register={address2}
              label="Address - Line 2"
              maxLength={validationTypes.address2.maxLength}
              errors={errors}
              placeholder="Address - Line 2"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <TextInput
              required={validationTypes.city.required}
              register={city}
              label="City"
              maxLength={validationTypes.city.maxLength}
              errors={errors}
              placeholder="City"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <label className={styles.formLabel}>
              State<div className={styles.fieldRequired}>*</div>
            </label>
            <CountryDropdown
              id="changeAdd"
              name={STATE_REGISTER}
              // label={'State'}
              tkey="title"
              pkey="alias"
              options={Object.values(statesWithId)}
              {...register(STATE_REGISTER, { required: true })}
              optionsOrder={[2]}
              required={validationTypes.state.required}
              onChange={(e) =>
                handleInputOnChange(STATE_REGISTER, e.target.value)
              }
            />
            {getValidationMessage(errors, STATE_REGISTER)}
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="Zip Code"
              required={validationTypes.zip.required}
              register={zip}
              maxLength={validationTypes.zip.maxLength}
              errors={errors}
              placeholder="Zip Code"
            />
          </div>
        </div> */}
        <BaseAddress
          key=""
          id=""
          rdxUpdateAddressCB={(address) => setCurrentAddress(address)}
          hookFormCB={{
            register,
            formState,
            handleSubmit,
            clearErrors,
            trigger,
            getValues,
            setValue,
          }}
          data={currentAddress}
        />

        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <TextInput
              required={validationTypes.email.required}
              register={email}
              label="Email Address"
              maxLength={validationTypes.email.maxLength}
              errors={errors}
              placeholder="Email Address"
            />
          </div>
        </div>
        <div className={styles.Pause_cancelContainer}>
          <label className={styles.formLabel}>
            I want to <div className={styles.fieldRequired}>*</div>
          </label>{' '}
          <div className={styles.radioButtonContainer}>
            <div
              className={styles.radioButton}
              onClick={() => handleRadioButton('Pause')}
            >
              <input type="radio" checked={pauseRadioButtonActive} />
              <p className={styles.paragraph}>Pause my subscription</p>
            </div>

            <div
              className={styles.radioButton}
              onClick={() => handleRadioButton('Cancel')}
            >
              <input type="radio" checked={cancelRadioButtonActive} />
              <p className={styles.paragraph}> Cancel my subscription</p>
            </div>
          </div>
        </div>
        {pauseRadioButtonActive && (
          <div className={styles.Pause_cancelContainer}>
            <label
              className={styles.formLabel}
            >{`Pause all orders until (Optional)`}</label>
            <div className={styles.radioButtonContainer}>
              {DatepickerComponent(resumeDate || null, setResumeDate, {
                minDate: new Date(),
              })}
            </div>
          </div>
        )}
        {cancelRadioButtonActive && (
          <div className={styles.inputRowContainer}>
            <div className={styles.inputBoxContainerSingle}>
              <label className={styles.formLabel}>
                Reason for Cancellation
                <div className={styles.fieldRequired}>*</div>
              </label>
              <div className={styles.stateDropdown}></div>
              {SelectDropdown(
                'cancelReasons',
                'cancel',
                displayCancellationReasons.filter(
                  (value) => value !== '-- Choose a Reason --'
                ) || [],
                cancellation,
                'cancellation',
                errors,
                clearErrors,
                'Select Cancellation Reason'
              )}
            </div>
          </div>
        )}
        <div className={styles.questionsCommentsContainer}>
          <label>Comments/Questions</label>
          <div className={styles.questionsComments}>
            <TextAreaInput
              className={styles.questionTextArea}
              id="questionsComments"
              minRows={4}
              onChange={(e) => {
                clearErrors(COMMENTS_REGISTER);
              }}
              register={comments}
            />
          </div>
          <div className={styles.sendButtonContainer}>
            <ContainedButton
              btnType="dark"
              className={styles.submitRequestButton}
            >
              Submit Request
            </ContainedButton>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CancelForm;
